"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-statebrowser-network",
    class: [_vm.isActiveNetwork ? 'app-statebrowser-network--active' : '']
  }, [_c('div', {
    staticClass: "app-statebrowser-network-header"
  }, [_c('a', {
    staticClass: "app-statebrowser-network-name u-link",
    on: {
      "click": function ($event) {
        return _vm.setActiveBuffer(_vm.serverBuffer);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.network.name) + " ")]), _c('div', {
    staticClass: "app-statebrowser-buffer-actions"
  }, [_c('div', {
    staticClass: "app-statebrowser-channel-labels"
  }, [_vm.serverUnread && _vm.showMessageCounts(_vm.serverBuffer) ? _c('div', {
    staticClass: "app-statebrowser-channel-label",
    class: [_vm.serverHighlight ? 'app-statebrowser-channel-label--highlight' : '']
  }, [_vm._v(" " + _vm._s(_vm.serverUnread > 999 ? "999+" : _vm.serverUnread) + " ")]) : _vm._e()])]), _c('div', {
    staticClass: "app-network-name-options"
  }, [_vm.totalNetworkCount > 1 ? _c('div', {
    staticClass: "app-network-name-option app-network-name-option-collapse",
    on: {
      "click": function ($event) {
        _vm.collapsed = !_vm.collapsed;
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.collapsed ? 'fa-plus-square-o' : 'fa-minus-square-o']
  })]) : _vm._e()])]), _c('transition-expand', [_vm.channel_filter_display ? _c('div', {
    staticClass: "app-statebrowser-channelfilter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.channel_filter,
      expression: "channel_filter"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "placeholder": _vm.$t('filter_channels'),
      "type": "text"
    },
    domProps: {
      "value": _vm.channel_filter
    },
    on: {
      "blur": _vm.onChannelFilterInputBlur,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.closeFilterChannel.apply(null, arguments);
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.channel_filter = $event.target.value;
      }
    }
  }), _c('p', [_c('a', {
    on: {
      "click": function ($event) {
        _vm.closeFilterChannel();
        _vm.showNetworkChannels(_vm.network);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('find_more_channels')) + " ")])])]) : _vm._e(), _vm.channel_add_display ? _c('div', {
    staticClass: "app-statebrowser-channels-info"
  }, [_c('form', {
    staticClass: "app-statebrowser-newchannel",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitNewChannelForm.apply(null, arguments);
      }
    }
  }, [_c('div', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "app-statebrowser-newchannel-inputwrap",
    class: [_vm.channel_add_input_has_focus ? 'app-statebrowser-newchannel-inputwrap--focus' : '']
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.channel_add_input,
      expression: "channel_add_input"
    }],
    attrs: {
      "placeholder": _vm.$t('state_join'),
      "type": "text"
    },
    domProps: {
      "value": _vm.channel_add_input
    },
    on: {
      "focus": _vm.onNewChannelInputFocus,
      "blur": _vm.onNewChannelInputBlur,
      "keydown": _vm.onNewChannelKeyDown,
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.channel_add_input = $event.target.value;
      }
    }
  })]), _c('auto-complete', {
    ref: "autocomplete",
    staticClass: "app-statebrowser-newchannel-autocomplete",
    attrs: {
      "items-per-page": "5",
      "items": _vm.suggestedChannelsList,
      "filter": _vm.channel_add_input
    },
    on: {
      "click": _vm.onNewChannelClick,
      "selected": _vm.onNewChannelSelected
    }
  })], 1)]) : _vm._e()]), _c('div', {
    staticClass: "app-statebrowser-network-toggable-area",
    class: [_vm.collapsed ? 'app-statebrowser-network-toggable-area--collapsed' : '']
  }, [_c('transition-expand', [_vm.network.state !== 'connected' ? _c('div', {
    staticClass: "app-statebrowser-network-status"
  }, [_vm.network.state_error ? [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    staticClass: "u-link",
    on: {
      "click": function ($event) {
        return _vm.showNetworkSettings(_vm.network);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('state_configure')) + " ")])] : !_vm.network.connection.server ? [_c('a', {
    staticClass: "u-link",
    on: {
      "click": function ($event) {
        return _vm.showNetworkSettings(_vm.network);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('state_configure')) + " ")])] : _vm.network.state === 'disconnected' ? [_vm._v(" " + _vm._s(_vm.$t('state_disconnected')) + " "), _c('a', {
    staticClass: "u-link",
    on: {
      "click": function ($event) {
        return _vm.network.ircClient.connect();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('connect')) + " ")])] : _vm.network.state === 'connecting' ? [_vm._v(" " + _vm._s(_vm.$t('connecting')) + " ")] : _vm._e()], 2) : _vm._e(), !_vm.showBufferGroups && !_vm.channel_filter_display && !_vm.channel_add_display ? _c('div', {
    staticClass: "app-statebrowser-network-options"
  }, [_c('div', {
    staticClass: "app-statebrowser-network-option",
    class: {
      active: !!_vm.channel_add_display
    },
    on: {
      "click": function ($event) {
        return _vm.toggleAddChannel();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('div', {
    staticClass: "app-statebrowser-network-option",
    class: {
      active: !!_vm.channel_filter_display
    },
    on: {
      "click": function ($event) {
        return _vm.onSearchChannelClick();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]), _vm.network.state === 'connected' ? _c('div', {
    staticClass: "app-statebrowser-joinchannel",
    on: {
      "click": function ($event) {
        return _vm.openChannelList();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("Rejoindre un salon")])]) : _vm._e(), _vm.show_channellist ? _c('div', {
    staticClass: "app-channellist-modal",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        _vm.show_channellist = false;
      }
    }
  }, [_c('div', {
    staticClass: "app-channellist-modal-box"
  }, [_c('button', {
    staticClass: "app-channellist-modal-close",
    attrs: {
      "type": "button",
      "title": _vm.$t('close')
    },
    on: {
      "click": function ($event) {
        _vm.show_channellist = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('div', {
    staticClass: "app-channellist-modal-scroll"
  }, [_c('channel-list', {
    attrs: {
      "network": _vm.network
    },
    on: {
      "close": function ($event) {
        _vm.show_channellist = false;
      }
    }
  })], 1)])]) : _vm._e(), _c('div', {
    staticClass: "app-statebrowser-tabs"
  }, [_c('button', {
    staticClass: "app-statebrowser-tab",
    class: {
      'app-statebrowser-tab--active': _vm.activeTab === 'channels'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.activeTab = 'channels';
      }
    }
  }, [_c('svg', {
    staticClass: "app-statebrowser-tab-icon app-statebrowser-tab-icon--bubble",
    attrs: {
      "viewBox": "0 0 1500 1500",
      "fill": "currentColor",
      "fill-rule": "evenodd",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M753.5 44.1C364.2 44.1 48.5 333.4 48.5 690.4c0 140 49.1 269.3\n                            131.8 375.2L53 1372.9c-12.4 30 1.8 64.3 31.8 76.7 15 6.2 31.1 5.8\n                            45 0l374.9-155.3c77.4 26.9 161.1 42.3 248.9 42.3 389.5 0 705-289.5\n                            705-646.3S1143 44.1 753.5 44.1zM459.8 778.5a88.1 88.1 0 1 1\n                            0-176.3 88.1 88.1 0 0 1 0 176.3zm293.7 0a88.1 88.1 0 1 1 0-176.3\n                            88.1 88.1 0 0 1 0 176.3zm293.8 0a88.1 88.1 0 1 1 0-176.3 88.1 88.1\n                            0 0 1 0 176.3z"
    }
  })]), _c('span', {
    staticClass: "app-statebrowser-tab-label"
  }, [_vm._v("Salons")])]), _c('button', {
    staticClass: "app-statebrowser-tab",
    class: {
      'app-statebrowser-tab--active': _vm.activeTab === 'queries'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.activeTab = 'queries';
      }
    }
  }, [_c('svg', {
    staticClass: "app-statebrowser-tab-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }
  }, [_c('rect', {
    attrs: {
      "x": "1.5",
      "y": "4",
      "width": "21",
      "height": "16",
      "rx": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "m1.5 6 10.5 7L22.5 6"
    }
  })]), _c('span', {
    staticClass: "app-statebrowser-tab-label"
  }, [_vm._v("Privés")]), _vm.queryActivity.unread > 0 ? _c('span', {
    staticClass: "app-statebrowser-tab-badge"
  }, [_vm._v(_vm._s(_vm.queryActivity.unread > 999 ? '999+' : _vm.queryActivity.unread))]) : _vm._e()])]), _c('div', {
    staticClass: "app-statebrowser-buffers",
    attrs: {
      "data-name": _vm.activeTab
    }
  }, [_c('transition-expand', [_vm.activeTabBuffers.length ? _c('div', {
    staticClass: "app-statebrowser-buffers-container"
  }, _vm._l(_vm.activeTabBuffers, function (buffer) {
    return _c('buffer', {
      key: buffer.name,
      attrs: {
        "buffer": buffer,
        "active-prompt": _vm.activePrompt
      },
      on: {
        "selected": function ($event) {
          return _vm.setActiveBuffer(buffer);
        }
      }
    });
  }), 1) : _vm._e()]), !_vm.activeTabBuffers.length ? _c('div', {
    staticClass: "app-statebrowser-tab-empty"
  }, [_vm._v(" " + _vm._s(_vm.activeTab === 'queries' ? 'Aucune conversation privée' : 'Aucun salon') + " ")]) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];